import React, { Component } from 'react'

class DashboardBox extends Component {
  render () {
    /* eslint-disable */
    if (this.props.connected) return null
    return (
      <div className='offline-indicator-installation'>
        <div className='indicator text-left'>
          <i className='fa fa-cog fa-spin'></i>
          <span>Connection lost, Installation will restart when connection is regained.</span>
        </div>
      </div>
    )
  }
}
export default DashboardBox



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/components/core/OfflineIndicator.js